module.exports = {
  "version": "0.27.0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/env/data.js
// module id = PNE4
// module chunks = 0